import { error } from 'jquery'
import { memberType } from '../types/memberType'

/* eslint-disable default-case */

const initialState = {
  loading: false,
  memberCovered: [],
  additionPermission: null,
  updatedDependent: null,
  memberData: [],
  productsDetails: {},
  error: null
}

export const MemberReducer = (state = initialState, action) => {
  switch (action.type) {
    //get_employee_dependents

    case memberType.memberCoveredFail:
      return {
        ...state,
        error: action.payload,
        loading: false
      }

    case memberType.memberCoveredPending:
      return {
        ...state,
        loading: true
      }

    case memberType.memberCoveredSuccess:
      return {
        ...state,
        memberCovered: action.payload.data,
        loading: false
      }
    //get_dependent_addition_permission
    case memberType.additionPermissionFail:
      return {
        ...state,
        error: action.payload,
        loading: false
      }

    case memberType.additionPermissionPending:
      return {
        ...state,
        loading: true
      }

    case memberType.additionPermissionSuccess:
      return {
        ...state,
        additionPermission: action.payload.data,
        loading: false
      }
    //(remove dependent) update_employee_dependents

    case memberType.removeDependentFail:
      return {
        ...state,
        error: action.payload,
        loading: false
      }

    case memberType.removeDependentPending:
      return {
        ...state,
        loading: true
      }

    case memberType.removeDependentSuccess:
      return {
        ...state,
        loading: false
      }
    //(UPDATE dependent) update_employee_dependents

    case memberType.updateDependentFail:
      return {
        ...state,
        error: action.payload,
        loading: false
      }

    case memberType.updateDependentPending:
      return {
        ...state,
        loading: true
      }

    case memberType.updateDependentSuccess:
      return {
        ...state,
        updatedDependent: action.payload.data,
        loading: false
      }
    case memberType.persitMembersAdd:

      return {
        ...state,
        memberData: [...state.memberData, action.payload]
      }
    case memberType.persitMembersRemove:
      return {
        ...state,
        memberData: state.memberData.filter(
          id => id !== action.payload
        )
      }

    case memberType.getEmployeeProductsPending:
      return {
        ...state,
        loading: true
      }
    case memberType.getEmployeeProductsSuccess:
      return {
        ...state,
        productsDetails: action.payload.data,
        loading: false
      }
    case memberType.getEmployeeProductsFail:
      return {
        ...state,
        error: action.payload.data,
        loading: false
      }
    default:
      return state
  }
}
